import React from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { ManageRulesPage } from 'page-components/auto-ticket-rules'

export const AutoTicketRulesManageScreen = () => {
    const { templateId } = useParams()
    const location = useLocation()
    const templateName = location.state?.templateName

    return (
        <ManageRulesPage
            templateId={templateId}
            templateName={templateName}
        />
    )
}
